export const getLangFromLocale = (locale: string): string => {
  return locale?.split('-')[0];
};

export const getCountryFromLocale = (locale: string): string => {
  const explodedLocale = locale?.split('-');
  if (!explodedLocale) {
    return undefined;
  }
  return explodedLocale[1] ?? explodedLocale[0];
};

export function getAngularLocale(locale: string): string {
  const deduplicatedLocale = deduplicateLocale(locale);
  const angularLangMatching = {
    'en-US': 'en', // default en is US in angular
    'en-MY': 'en',
    'en-TH': 'en',
    'en-CH': 'en',
    'en-ID': 'en',
  };

  return angularLangMatching[locale] || deduplicatedLocale;
}

export function getDateFnsLocale(locale: string): string {
  const deduplicatedLocale = deduplicateLocale(locale);
  const dateFnsLangMatching = {
    'en-ID': 'en-US',
    'en-SG': 'en-US',
    'en-MY': 'en-US',
    'en-TH': 'en-US',
    'en-CH': 'en-US',
    'es-CL': 'es',
    'es-CO': 'es',
    'es-ES': 'es',
    'es-MX': 'es',
    'it-CH': 'it',
    'de-CH': 'de',
    'bg-BG': 'bg',
    'pt-BR': 'br',
  };

  return dateFnsLangMatching[locale] || deduplicatedLocale;
}

// some library does not handle duplicate locale fr-FR, pt-PT but just fr, pt
export function deduplicateLocale(locale: string): string {
  const isDuplicateLocale = new RegExp(/\b(\w+)\b.*\b\1\b/gi).exec(locale);

  return isDuplicateLocale ? isDuplicateLocale[1] : locale;
}
